import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=f9106b1c&"
import script from "./Deliveries.vue?vue&type=script&lang=ts&"
export * from "./Deliveries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports